import { render, staticRenderFns } from "./ProductLevelDetails.vue?vue&type=template&id=47efbb09&scoped=true"
import script from "./ProductLevelDetails.vue?vue&type=script&lang=js"
export * from "./ProductLevelDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductLevelDetails.vue?vue&type=style&index=0&id=47efbb09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efbb09",
  null
  
)

export default component.exports